import { render, staticRenderFns } from "./MyFolders.vue?vue&type=template&id=1d563490&scoped=true&"
import script from "./MyFolders.vue?vue&type=script&lang=js&"
export * from "./MyFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d563490",
  null
  
)

export default component.exports